import { mergeObjectTypes } from '../cacheHelpers';

const BookingManagementSettings = {
  merge: mergeObjectTypes
};

export default BookingManagementSettings;
